import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CouponsectionService } from 'src/app/services/couponsection.service';

@Component({
  standalone: false,
  selector: 'app-remove-modal-coupon',
  templateUrl: './remove-modal-coupon.component.html',
  styleUrls: ['./remove-modal-coupon.component.scss'],
})
export class RemovemodalcouponComponent implements OnInit {
  @Input() couponId: string;
  @Input() fromDetailsPage: any;
  @Input() fromListPage: any;

  listCouponIds = [];

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private customergroupService: CouponsectionService
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void { }

  deleteCouponData() {
    this.listCouponIds = [];
    this.customergroupService
      .removeCoupon(this.couponId)
      .subscribe((res) => {
        console.log(res);
        if (res.isValid) {
          if (this.fromListPage == 'yes') {
            location.reload();
          } else {
            this.router.navigate(['/list-coupon/']);
          }
        }
      });
    this.modal.dismiss();
  }
}
